export class UnexpectedError extends Error {
  code?: string;

  constructor(code?: any) {
    super(`Ops. Algo de errado aconteceu. ${code ? `cod:${code}` : ''}`);
    this.name = 'UnexpectedError';
  }
}
